export default __webpack_public_path__ + "static/media/DCAU.9d9e41d3.png";